import { ApolloError } from '@apollo/client';
import { examsRoleByStudent as schemaExamsRole } from './schemas';
import apiClient from './apiClient';
import ExamsRoleByStudentDataStore from '../../datastores/ExamsRoleByStudentDataStore';

class ExamsRoleByStudentDataStoreGraphQL
  implements ExamsRoleByStudentDataStore
{
  async getExamsRoleByStudent(career: string, period: string) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaExamsRole.getExamsRoleByStudent,
        variables: {
          career,
          period
        },
        fetchPolicy: 'cache-first'
      });
      return response.data?.examsRole?.examsRoleByStudent;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error(
          `No se pudo obtener los roles (career=${career}, period=${period})`
        );
      }
      throw err;
    }
  }
}

export default ExamsRoleByStudentDataStoreGraphQL;
